module.exports = __webpack_public_path__ + "img/menu-img.4c3c0dcf.svg";